module.exports = __webpack_public_path__ + "media/application/images/svgs/edit-2-498d1ced9f352628702cc7508dee3e49.svg";